export default "__VITE_ASSET___vWyo5uw__"